// // import React, { useEffect, useState } from 'react';
// // import { doc, getDoc, collection, getDocs, query, where } from 'firebase/firestore';
// // import { auth, db } from '../firebase/config';
// // import { onAuthStateChanged } from 'firebase/auth';
// // import Table from 'react-bootstrap/Table';
// // import { Button } from "react-bootstrap";
// //
// // function FacultyClassesTable() {
// //     const [enrolledCourses, setEnrolledCourses] = useState([]);
// //
// //     useEffect(() => {
// //         const unsubscribe = onAuthStateChanged(auth, async (user) => {
// //             if (user) {
// //                 const userEmail = user.email;
// //
// //                 const classesCollection = collection(db, "classes");
// //                 const q = query(classesCollection, where('email', '==', userEmail));
// //
// //                 const classesSnapshot = await getDocs(q);
// //                 const classesList = classesSnapshot.docs.map(course => ({
// //                     id: course.id,
// //                     ...course.data()
// //                 }));
// //
// //                 setEnrolledCourses(classesList);
// //             }
// //         });
// //
// //         return () => unsubscribe();
// //     }, []);
// //    async function showStudents(){
// //
// //     }
// //
// //     return (
// //         <Table striped bordered hover responsive>
// //             <thead>
// //                 <tr>
// //                     <th class="greenHeader">Course Name</th>
// //                     <th class="greenHeader">Course Number</th>
// //                     {/* <th class="greenHeader">Section</th> */}
// //                     <th class="greenHeader">Enrolled Students</th>
// //                   <th className="greenHeader">Delete Class</th>
// //                   <Button variant="success" onClick={() => handleDelete(cls.id)}>
// //                     Delete
// //                   </Button>
// //                 </tr>
// //             </thead>
// //             <tbody>
// //                 {enrolledCourses.map(course => (
// //                     <tr key={course.id}>
// //                         <td>{course.name}</td>
// //                         <td>{course.abbreviatedName}</td>
// //                         {/* <td>{course.section}</td> */}
// //                         <td><button onClick = {{showStudents}} style = {{background: "none", border: "none"}}>12</button></td>
// //                     </tr>
// //                 ))}
// //             </tbody>
// //         </Table>
// //     );
// // }
// //
// // export default FacultyClassesTable;
// import React, { useEffect, useState } from 'react';
// import { doc, getDoc, collection, getDocs, query, where, deleteDoc } from 'firebase/firestore';
// import { auth, db } from '../firebase/config';
// import { onAuthStateChanged } from 'firebase/auth';
// import Table from 'react-bootstrap/Table';
// import { Button } from "react-bootstrap";
//
// function FacultyClassesTable() {
//   const [enrolledCourses, setEnrolledCourses] = useState([]);
//
//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (user) => {
//       if (user) {
//         const userEmail = user.email;
//         const classesCollection = collection(db, "classes");
//         const q = query(classesCollection, where('email', '==', userEmail));
//         const classesSnapshot = await getDocs(q);
//
//         const classesList = classesSnapshot.docs.map(course => ({
//           id: course.id,
//           ...course.data()
//         }));
//
//         setEnrolledCourses(classesList);
//       }
//     });
//
//     return () => unsubscribe();
//   }, []);
//
//   const showStudents = () => {
//     alert("Show students modal or redirect coming soon!");
//   };
//
//   const handleDelete = async (classId) => {
//     try {
//       await deleteDoc(doc(db, "classes", classId));
//       setEnrolledCourses(prev => prev.filter(course => course.id !== classId));
//     } catch (error) {
//       console.error("Error deleting class:", error);
//     }
//   };
//
//   return (
//     <Table striped bordered hover responsive>
//       <thead>
//       <tr>
//         <th className="greenHeader">Course Name</th>
//         <th className="greenHeader">Course Number</th>
//         <th className="greenHeader">Enrolled Students</th>
//         <th className="greenHeader">Delete Class</th>
//       </tr>
//       </thead>
//       <tbody>
//       {enrolledCourses.map(course => (
//         <tr key={course.id}>
//           <td>{course.name}</td>
//           <td>{course.abbreviatedName}</td>
//           <td>
//             <button
//               onClick={showStudents}
//               style={{ background: "none", border: "none", color: "#00704a", cursor: "pointer" }}
//             >
//               View
//             </button>
//           </td>
//           <td>
//             <Button
//               variant="danger"
//               onClick={() => handleDelete(course.id)}
//             >
//               Delete
//             </Button>
//           </td>
//         </tr>
//       ))}
//       </tbody>
//     </Table>
//   );
// }
//
// export default FacultyClassesTable;
import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where, deleteDoc, doc } from 'firebase/firestore';
import { auth, db } from '../firebase/config';
import { onAuthStateChanged } from 'firebase/auth';
import Table from 'react-bootstrap/Table';
import { Button } from "react-bootstrap";

function FacultyClassesTable() {
  const [enrolledCourses, setEnrolledCourses] = useState([]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userEmail = user.email;
        const classesCollection = collection(db, "classes");
        const q = query(classesCollection, where('email', '==', userEmail));
        const classesSnapshot = await getDocs(q);
        const classesList = classesSnapshot.docs.map(course => ({
          id: course.id,
          ...course.data()
        }));
        setEnrolledCourses(classesList);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleDelete = async (classId) => {
    try {
      await deleteDoc(doc(db, "classes", classId));
      setEnrolledCourses(prev => prev.filter(course => course.id !== classId));
    } catch (error) {
      console.error("Error deleting class:", error);
    }
  };

  return (
    <Table striped bordered hover responsive>
      <thead>
      <tr>
        <th className="greenHeader">Course Name</th>
        <th className="greenHeader">Course Number</th>
        <th className="greenHeader">Enrolled Students</th>
        <th className="greenHeader">Delete Class</th>
      </tr>
      </thead>
      <tbody>
      {enrolledCourses.map(course => (
        <tr key={course.id}>
          <td>{course.name}</td>
          <td>{course.abbreviatedName}</td>
          <td>
            <button style={{ background: "none", border: "none" }}>12</button>
          </td>
          <td>
            <Button variant="success" onClick={() => handleDelete(course.id)}>
              Delete
            </Button>
          </td>
        </tr>
      ))}
      </tbody>
    </Table>
  );
}

export default FacultyClassesTable;
